// src/store/modules/checkExamRestriction.ts
import { Module } from 'vuex'
import CheckExamRestrictionService from '@/services/Localization/EditRestriction'
import i18n from '@/i18n'
import { handle418Error } from '@/utils/errorHandlers'
import { useToast } from 'vue-toastification'
const toast = useToast()
interface CheckExamRestrictionState {
  result: any | null
  loading: boolean
  error: string | null
}

const checkExamRestriction: Module<CheckExamRestrictionState, any> = {
  namespaced: true,

  state: () => ({
    result: null,
    loading: false,
    error: null,
  }),

  mutations: {
    SET_RESULT(state, payload) {
      state.result = payload
    },
    SET_LOADING(state, status) {
      state.loading = status
    },
    SET_ERROR(state, error) {
      state.error = error
    },
  },

  actions: {
    async check({ commit ,dispatch}, params: { exam_id?: number; exam_localization_id?: number }) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      const id = params.exam_id ?? params.exam_localization_id
      try {
        const response = await CheckExamRestrictionService.check(params)
        commit('SET_RESULT', response.data)
        return response.data
      } catch (error: any) {
        commit('SET_ERROR', error.message || 'Something went wrong')
        if (error.status === 418) {
                const title = `${i18n.global.t('exams.edit')} “${id}”`
       if (!handle418Error(dispatch, error, title )) {
         toast.error(error)
       }
         }
      } finally {
        commit('SET_LOADING', false)
      }
    },
  },
}

export default checkExamRestriction
